// Unpublished Work © 2022-2026 Deere & Company.

import React from 'react';
import {fetchEffectData} from 'Utils/react-utils';
import PropTypes from 'Utils/prop-type-utils';
import DataGridWrapper from 'Src/ui-core/components/common/data-table/data-grid-wrapper';

function EquipmentTab(props) {
    const {tableProps} = props;

    const [data, setData] = React.useState(() => []);
    const [loading, setLoading] = React.useState(() => true);

    React.useEffect(() => fetchEffectData(async (isMounted) => {
        setLoading(true);
        const data = await tableProps.rowsData();

        if (isMounted()) {
            setData(data);
            setLoading(false);
        }
    }), [tableProps.equipment]);

    const filteredData = React.useMemo(() => tableProps.filterList ? tableProps.filterData(data) : data, [data, tableProps.filterList]);

    return (<div className={`table-scroll ${tableProps.className}`}><DataGridWrapper
        {...tableProps}
        loading={tableProps.loading || loading}
        rows={filteredData}
    /></div>);
}

EquipmentTab.propTypes = {
    tableProps: PropTypes.object
};

export default EquipmentTab;
